const ListTable = require('app/ui/list/Table');
const ConfirmModal = require('app/ui/modal/Confirm');
const GraphQLMutation = require('app/graphql/Mutation');

const CreateModal = require('app/restaurant/CreateModal');
const CopyModal = require('app/restaurant/CopyModal');
const ExcelModal = require('app/restaurant/export/ExcelModal');

class ListView {
    defaultOptions() {
        return {
            'selector': '.view-restaurant-list',
            'tableContainerSelector': '.restaurant-list-container',
            'filterFormSelector': '.restaurant-list-search-form',

            'restaurantShowBaseUrl': window.App.get('restaurantShowBaseUrl'),
            'restaurantAnalyseBaseUrl': window.App.get('restaurantAnalyseBaseUrl'),
            'restaurantUsersBaseUrl': window.App.get('restaurantUsersBaseUrl'),
            'restaurantSupplierBaseUrl': window.App.get('restaurantSupplierBaseUrl'),
            'restaurantBookmarkBaseUrl': window.App.get('restaurantBookmarkBaseUrl'),
            'restaurantStatBaseUrl': window.App.get('restaurantStatBaseUrl'),
            'restaurantTrameBaseUrl': window.App.get('restaurantTrameBaseUrl'),
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.buildGraphQLParameters = this.buildGraphQLParameters.bind(this);
        this.onSubmitFilterForm = this.onSubmitFilterForm.bind(this);
        this.onClickCreate = this.onClickCreate.bind(this);
        this.onClickExport = this.onClickExport.bind(this);

        this.$container = $(this.settings.selector);
        if (this.$container.length <= 0) {
            window.notify("Can't find container view with selector " + this.settings.selector, 'danger');
        }

        this.$tableContainer = $(this.settings.tableContainerSelector, this.$container);
        this.$filterForm = $(this.settings.filterFormSelector, this.$container);
        this.$btnCreate = $('.btn-restaurant-create');
        this.$btnExport = $('.btn-restaurant-export');

        this.initialize();
    }

    initialize() {
        var self = this;

        this.initializeFilterForm();
        this.initializeListTable();
        this.bindEvents();
    }

    initializeFilterForm() {
        var self = this;

        this.$filterOrderBy = $('select[name="orderBy"]', this.$filterForm);
        this.$filterOrderBy.on('change', this.onSubmitFilterForm);

        this.$filterByName = $('input[name="name"]', this.$filterForm);
        this.$filterByName.on('change', this.onSubmitFilterForm);

        this.$filterByDeliveryDay = $('select[name="deliveryDay"]', this.$filterForm);
        this.$filterByDeliveryDay.on('change', this.onSubmitFilterForm);

        this.$filterBySupplier = $('select[name="supplier"]', this.$filterForm);
        this.$filterBySupplier.on('change', this.onSubmitFilterForm);

        this.$filterByType = $('select[name="type"]', this.$filterForm);
        this.$filterByType.on('change', this.onSubmitFilterForm);

        this.$filterBySeller = $('select[name="seller"]', this.$filterForm);
        this.$filterBySeller.on('change', this.onSubmitFilterForm);

        this.$filterByMutualisedCustomer = $('select[name="mutualisedCustomer"]', this.$filterForm);
        this.$filterByMutualisedCustomer.on('change', this.onSubmitFilterForm);

        this.$filterByPreset = $('input[name="preset"]', this.$filterForm);
        this.$filterByPreset.on('change', this.onSubmitFilterForm);

        this.$filterOnlyWithOrder = $('input[name="onlyWithOrder"]', this.$filterForm);
        this.$filterOnlyWithOrder.on('change', this.onSubmitFilterForm);

        this.$filterForm.on('submit', this.onSubmitFilterForm);

    }

    onSubmitFilterForm(event) {
        event.preventDefault()
        event.stopPropagation();

        this.table.refresh();
    }

    refresh() {
        this.table.refresh();
    }


    initializeListTable() {
        var self = this;

        let fields = [
            'id',
            'name',
            'createdAt',
        ];

        this.table = new ListTable({
            '$container': this.$tableContainer,
            'tableClass': 'table table-striped restaurant-list',
            'id': 'list-restaurants',
            'length': 50,
            'graphQL': {
                'queryType': 'restaurants',
                'fields': fields,
                'parameters': this.buildGraphQLParameters,

            },
            'columns': [
                {
                    'name': 'createdAt',
                    'label': window.translate('restaurant.createdAt.label'),
                    'class': 'restaurant-date',
                    'render': function (item, index) {
                        return window.formatDate(item.node.createdAt, window.translate('momentDateFormat.fullDay'));
                    },
                },
                {
                    'name': 'name',
                    'label': window.translate('restaurant.name.label'),
                    'ordered': true,
                    'orderType': 'name',
                    'orderDir': 'ASC',
                    'class': 'restaurant-name',
                    'render': function (item, index) {
                        //@todo traité le message "Certains fournisseurs n'ont pas de jours de livraison paramétrés" (peut être avec un nouveau attribut dans GraphQL qui fait appel à une fonction)
                        return item.node.name;
                    },
                },
                {
                    'name': 'actions',
                    'label': '',
                    'class': 'restaurant-actions',
                    'render': function (item, index) {
                        let $list = $('<ul/>')
                            .addClass('list-inline btn-list-inline');

                        let btns = [];

                        let urlEdit = self.settings.restaurantShowBaseUrl.replace('__ID__', item.node.id);
                        let $btnEdit = $('<a/>')
                            .attr('href', urlEdit)
                            .addClass('btn btn-link iframe fancy')
                            .attr('data-fancybox', '')
                            .attr('data-type', 'iframe')
                            .attr('title', window.translate('restaurant.actions.edit.label'))
                            .append(
                                $('<i/>')
                                    .addClass('fas fa-edit')
                            );
                        btns.push($btnEdit);

                        let urlAnalyse = self.settings.restaurantAnalyseBaseUrl.replace('__ID__', item.node.id);
                        let $btnAnalyse = $('<a/>')
                            .attr('href', urlAnalyse)
                            .addClass('btn btn-link iframe fancy')
                            .attr('data-fancybox', '')
                            .attr('data-type', 'iframe')
                            .attr('title', window.translate('restaurant.actions.analyse.label'))
                            .append(
                                $('<i/>')
                                    .addClass('fas fa-chart-pie')
                            );
                        btns.push($btnAnalyse);

                        let urlUser = self.settings.restaurantUsersBaseUrl.replace('__ID__', item.node.id);
                        let $btnUser = $('<a/>')
                            .attr('href', urlUser)
                            .addClass('btn btn-link iframe fancy')
                            .attr('data-fancybox', '')
                            .attr('data-type', 'iframe')
                            .attr('title', window.translate('restaurant.actions.user.label'))
                            .append(
                                $('<i/>')
                                    .addClass('fas fa-users')
                            );
                        btns.push($btnUser);

                        let urlSupplier = self.settings.restaurantSupplierBaseUrl.replace('__ID__', item.node.id);
                        let $btnSupplier = $('<a/>')
                            .attr('href', urlSupplier)
                            .addClass('btn btn-link iframe fancy')
                            .attr('data-fancybox', '')
                            .attr('data-type', 'iframe')
                            .attr('title', window.translate('restaurant.actions.supplier.label'))
                            .append(
                                $('<i/>')
                                    .addClass('fas fa-truck')
                            );
                        btns.push($btnSupplier);

                        let urlBookmark = self.settings.restaurantBookmarkBaseUrl.replace('__ID__', item.node.id);
                        let $btnBookmark = $('<a/>')
                            .attr('href', urlBookmark)
                            .addClass('btn btn-link iframe fancy')
                            .attr('data-fancybox', '')
                            .attr('data-type', 'iframe')
                            .attr('title', window.translate('restaurant.actions.bookmark.label'))
                            .append(
                                $('<i/>')
                                    .addClass('fas fa-star')
                            );
                        btns.push($btnBookmark);

                        let urlCopy = self.settings.restaurantShowBaseUrl.replace('__ID__', item.node.id);
                        let $btnCopy = $('<a/>')
                            .attr('href', urlCopy)
                            .addClass('btn btn-link iframe fancy')
                            .attr('data-fancybox', '')
                            .attr('data-type', 'iframe')
                            .attr('title', window.translate('restaurant.actions.copy.label'))
                            .append(
                                $('<i/>')
                                    .addClass('fas fa-copy')
                            );
                        btns.push($btnCopy);

                        let urlStat = self.settings.restaurantStatBaseUrl.replace('__ID__', item.node.id);
                        let $btnStat = $('<a/>')
                            .attr('href', urlStat)
                            .addClass('btn btn-link iframe fancy')
                            .attr('data-fancybox', '')
                            .attr('data-type', 'iframe')
                            .attr('title', window.translate('restaurant.actions.stat.label'))
                            .append(
                                $('<i/>')
                                    .addClass('fas fa-chart-line')
                            );
                        btns.push($btnStat);

                        let urlTrame = self.settings.restaurantTrameBaseUrl.replace('__ID__', item.node.id);
                        let $btnTrame = $('<a/>')
                            .attr('href', urlTrame)
                            .addClass('btn btn-link iframe fancy')
                            .attr('data-fancybox', '')
                            .attr('data-type', 'iframe')
                            .attr('title', window.translate('restaurant.actions.trame.label'))
                            .append(
                                $('<i/>')
                                    .addClass('fas fa-search')
                            );
                        btns.push($btnTrame);

                        let $btnModalCopy = $('<button/>')
                            .attr('type', 'button')
                            .addClass('btn btn-link iframe fancy')
                            .attr('data-fancybox', '')
                            .attr('data-type', 'iframe')
                            .attr('title', window.translate('restaurant.actions.modalCopy.label'))
                            .append(
                                $('<i/>')
                                    .addClass('fas fa-plus-circle')
                            )
                            .on('click', function (event) {
                                self.onClickModalCopy(item.node);
                            });
                        btns.push($btnModalCopy);

                        let $btnModalDelete = $('<button/>')
                            .attr('type', 'button')
                            .addClass('btn btn-link text-danger iframe fancy')
                            .attr('data-fancybox', '')
                            .attr('data-type', 'iframe')
                            .attr('title', window.translate('restaurant.actions.modalDelete.label'))
                            .append(
                                $('<i/>')
                                    .addClass('fas fa-trash')
                            )
                            .on('click', function (event) {
                                self.onClickDelete(item.node);
                            });
                        btns.push($btnModalDelete);

                        for (var i in btns) {
                            let $btn = btns[i];
                            $list.append(
                                $('<li/>')
                                    .addClass('list-inline-item')
                                    .append($btn)
                            );
                        }

                        return $list;
                    },
                },

            ]
        })
    }

    buildGraphQLParameters() {
        let filters = {
            'particulier': false
        };

        if (this.$filterByName && this.$filterByName.val()) {
            filters.name = '%' + this.$filterByName.val() + '%';
        }

        if (this.$filterByDeliveryDay && this.$filterByDeliveryDay.val()) {
            filters.deliveryDay = parseInt(this.$filterByDeliveryDay.val());
        }

        if (this.$filterBySupplier && this.$filterBySupplier.val()) {
            filters.supplier = parseInt(this.$filterBySupplier.val());
        }

        if (this.$filterByType && this.$filterByType.val()) {
            filters.type = parseInt(this.$filterByType.val());
        }

        if (this.$filterBySeller && this.$filterBySeller.val()) {
            filters.seller = parseInt(this.$filterBySeller.val());
        }

        if (this.$filterByMutualisedCustomer && this.$filterByMutualisedCustomer.val()) {
            filters.secondarySeller = parseInt(this.$filterByMutualisedCustomer.val());
        }

        if (this.$filterByPreset.is(':checked')) {
            filters.preset = true;
        }

        if (this.$filterOnlyWithOrder.is(':checked')) {
            filters.hasOrder = true;
        }

        let orderBy = this.$filterOrderBy.val();
        let dir = "ASC";
        if (orderBy == 'createdAt') {
            dir = "DESC";
        }
        let parameters = {
            'filter': filters,

            'orderBy': orderBy,
            'dir': dir,
        };


        return parameters;
    }

    bindEvents() {
        this.$btnCreate.on('click', this.onClickCreate)
        this.$btnExport.on('click', this.onClickExport)
    }
    onClickCreate(event) {
        var self = this;
        event.preventDefault();
        event.stopPropagation();

        let modal = new CreateModal({
            'onSuccess': function (data) {
                let restaurant = data.restaurant;
                let url = self.settings.restaurantShowBaseUrl.replace('__ID__', restaurant.id);
                window.redirect(url);
            }
        });
    }
    onClickExport(event) {
        event.preventDefault();
        event.stopPropagation();

        let modal = new ExcelModal({
            'parameters': this.buildGraphQLParameters(),
        });
    }

    onClickModalCopy(restaurant) {
        var self = this;
        event.preventDefault();
        event.stopPropagation();

        let modal = new CopyModal({
            'title': window.translate('app.restaurant.copy.title', { '%restaurantName%': restaurant.name }),
            'restaurant': restaurant,
            'onSuccess': function (data) {
                let newRestaurant = data.restaurant;
                let url = self.settings.restaurantShowBaseUrl.replace('__ID__', newRestaurant.id);
                window.redirect(url);
            }
        });
    }

    onClickDelete(restaurant) {
        var self = this;

        let $content = $('<div/>')
            .append(
                $('<div/>')
                    .append(window.translate('restaurant.actions.modalDelete.confirm', { '%restaurantName%': restaurant.name }))
            );

        let confirmModal = new ConfirmModal({
            'messageContent': $content,
            'btnConfirmClass': 'btn btn-danger btn-confirm',
            'btnCancelClass': 'btn btn-text text-secondary btn-cancel',
            'onConfirm': function (event, modal) {
                self.proceedDelete(restaurant, modal);
                window.notify(window.translate('restaurant.actions.modalDelete.success', { '%restaurantName%': restaurant.name }), 'success');
            },
            'onCancel': function (event, modal) {
                modal.show();
            }
        });

        confirmModal.show();
    }

    proceedDelete(restaurant, confirmModal) {

        var self = this;

        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'restaurant': {
                'value': restaurant.id,
                'type': 'Int!'
            }
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "DeleteRestaurant",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function () {
            },
            'success': function (data) {
                confirmModal.dispose();
                self.refresh();
            },
            'error': function (message, xhr) {
                confirmModal.dispose();
                window.notify(message, "error");
            },
            'after': function () {
                //do nothing
            }
        });
        mutation.execute();
    }
}

module.exports = ListView;

